<script lang="ts" setup>
import {ReccoRecommendationTypeDTO} from '@/ts/types/dto/recco/recommendation.dto';
import LoadingError from '@/vue/templates/loading-error.vue';
import ReccoArticleComponent from '@/vue/molecules/recco/recco-article-component.vue';
import ReccoAudioComponent from '@/vue/molecules/recco/recco-audio-component.vue';
import type {ReccoAudioDTO} from '@/ts/types/dto/recco/audio.dto';
import {useProvidedRecommendation} from '@/ts/composables/pure/use-provided-recommendation';
import {onMounted, onBeforeMount} from 'vue';
import ReccoVideoComponent from '@/vue/molecules/recco/recco-video-component.vue';
import type {ReccoVideoDTO} from '@/ts/types/dto/recco/video.dto';
import type {ReccoArticleDTO} from '@/ts/types/dto/recco/article.dto';
import BackLink from '@/vue/molecules/back-link.vue';
import {pagesPath} from '@/ts/router/pages-path';
import {useFeatureAccess} from '@/ts/composables/stateful/use-feature-access';
import {useRouter} from 'vue-router';

const {currentRecommendation, isLoading, enableUpdateOnPageParamChange, recommendationType} = useProvidedRecommendation();
const router = useRouter();
const {canAccessExplore} = useFeatureAccess();

// Check access before mounting
onBeforeMount(() => {
  if (!canAccessExplore.value) {
    // Redirect to paths page if user doesn't have access to explore
    void router.replace(pagesPath.intervention.interventionsList);
  }
});

onMounted(() => {
  enableUpdateOnPageParamChange();
});

const labelledById = crypto.randomUUID();

</script>

<template>
  <loading-error :id="labelledById" :loading="isLoading" type="page">
    <template #default>
      <div v-if="currentRecommendation" class="recommendation-page">
        <back-link class="back-link" :label="$t('recco_explore')" :to="pagesPath.main.explore" :hide-arrow="true"/>
        <recco-article-component
          v-if="recommendationType === ReccoRecommendationTypeDTO.Article"
          :article-recommendation="currentRecommendation as ReccoArticleDTO"
        />
        <recco-video-component
          v-else-if="recommendationType === ReccoRecommendationTypeDTO.Video"
          :video-recommendation="currentRecommendation as ReccoVideoDTO"
        />
        <recco-audio-component
          v-else-if="recommendationType === ReccoRecommendationTypeDTO.Audio"
          :audio-recommendation="currentRecommendation as ReccoAudioDTO"
        />
      </div>
    </template>
  </loading-error>
</template>

<style lang="scss" scoped>
.recommendation-page {
  @include page-alignment;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
}

.back-link {
  width: 100%;
  margin-bottom: 18px;
}
</style>